
(function(){
/*
	=======================================================
	
	SpielModus
	==========

	-------------------
	Default: xMas Mode
	-------------------
	Switch Modes
	1. HTML (switched die UI)
		- set on #switch-modes das Attribute [data-switch-type] auf "moki" oder "xmas"
		- inputs #radio-mode-moki, #radio-mode-xmas das Attribute [checked] auf "checked"
		- set audio Elementen source auf assets/sounds/[xmas,moki]/XX.mp3
	2. JS (switched die Sounds)
		set this.game_mode = moki oder xmas (String)

	======================================================
	Game States - Verändert die UI und aktiviert Buttons
	======================================================

	1. start (.tut-1)

	2. tutorial (.game-before)
		Erklärung des Spiels
			.tut-2
			.tut-3
			
		Los geht's Button,Ja,los!
			#game-start,#game-start-3

	3. playing
		Während des Spiels

	4. loose
		Spiel wird unmittelbar zurückgesetzt
		Restart Button

	=======================================================
	
	Switch Languages
	sucht den Parameter ?de oder ?en und setzt die Sprache
	Texte liegen im JS

*/

/*! modernizr 3.2.0 (Custom Build) | MIT *
 * http://modernizr.com/download/?-webaudio !*/
!function(n,e,o){function s(n,e){return typeof n===e}function a(){var n,e,o,a,i,l,r;for(var c in f)if(f.hasOwnProperty(c)){if(n=[],e=f[c],e.name&&(n.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(o=0;o<e.options.aliases.length;o++)n.push(e.options.aliases[o].toLowerCase());for(a=s(e.fn,"function")?e.fn():e.fn,i=0;i<n.length;i++)l=n[i],r=l.split("."),1===r.length?Modernizr[r[0]]=a:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=a),t.push((a?"":"no-")+r.join("-"))}}function i(n){var e=r.className,o=Modernizr._config.classPrefix||"";if(c&&(e=e.baseVal),Modernizr._config.enableJSClass){var s=new RegExp("(^|\\s)"+o+"no-js(\\s|$)");e=e.replace(s,"$1"+o+"js$2")}Modernizr._config.enableClasses&&(e+=" "+o+n.join(" "+o),c?r.className.baseVal=e:r.className=e)}var t=[],f=[],l={_version:"3.2.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(n,e){var o=this;setTimeout(function(){e(o[n])},0)},addTest:function(n,e,o){f.push({name:n,fn:e,options:o})},addAsyncTest:function(n){f.push({name:null,fn:n})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr,Modernizr.addTest("webaudio",function(){var e="webkitAudioContext"in n,o="AudioContext"in n;return Modernizr._config.usePrefixes?e||o:o});var r=e.documentElement,c="svg"===r.nodeName.toLowerCase();a(),i(t),delete l.addTest,delete l.addAsyncTest;for(var u=0;u<Modernizr._q.length;u++)Modernizr._q[u]();n.Modernizr=Modernizr}(window,document);

//_______________________ SET COOKIE
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return false;
}


//_______________________ DELETE COOKIE
var delete_cookie = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

//_______________________ HAS CLASS
function hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

//_______________________ in iFrame?
function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

    // Piwik-Tracking initialisieren
    var tracker;
		if (undefined !== parent.mobilekids) {
			tracker = new parent.mobilekids.tracking.GameTracking('XMAS-Special-2015');
		}

//====================================================== GAME FUNCTION

function GAME(){

	var that = this;
	var base_url = 'assets/sounds/';
	// URL um Highscore bzw. Anzahl richtiger Buttonclicks zu speichern
	var data_url = '/games/highscore';

	// ====================== GAME MODE
	// !! SET DEFAULT !! 
	// siehe oben switch Modes
	
	this.game_mode = 'moki';
	

	//_______________________ Data Layer
    
    this.buttons = [
      document.getElementById('game-cell-1'),
      document.getElementById('game-cell-2'),
      document.getElementById('game-cell-3'),
      document.getElementById('game-cell-4'),
      document.getElementById('game-cell-5'),
      document.getElementById('game-cell-6'),
      document.getElementById('game-cell-7'),
      document.getElementById('game-cell-8'),
      document.getElementById('game-cell-9')
   ];

   /*
		Wenn Audio Context nicht aktiv oder verfügbar werden 
		die Audio Files direkt über den Tag geladen
   */

   this.audioFiles = [
	  document.getElementById('audio-01'),
	  document.getElementById('audio-02'),
	  document.getElementById('audio-03'),
	  document.getElementById('audio-04'),
	  document.getElementById('audio-05'),
	  document.getElementById('audio-06'),
	  document.getElementById('audio-07'),
	  document.getElementById('audio-08'),
	  document.getElementById('audio-09'),
   ];
	
   /*
   		Wenn AudioContext verfügbar werden die AudioDateien 
   		über den SourceBuffer abgespielt
   */
   this.sounds = [
     base_url+ that.game_mode +'/01.mp3',
     base_url+ that.game_mode +'/02.mp3',
     base_url+ that.game_mode +'/03.mp3',
     base_url+ that.game_mode +'/04.mp3',
     base_url+ that.game_mode +'/05.mp3',
     base_url+ that.game_mode +'/06.mp3',
     base_url+ that.game_mode +'/07.mp3',
     base_url+ that.game_mode +'/08.mp3',
     base_url+ that.game_mode +'/09.mp3',
   ];
	
	//_______________________ VALUES

	var context;//der Audio Context

    this.bufferList = []; 
    this.ready = false;
    
    this.bufferLoader;
    this.player = 'name';
    this.level = 1;
    this.clickCounter = 0;
    this.speed = 1100; //mind 1s - Audio länge in ms
	this.score = 0;
	this.score_secret = 0;
	//wenn der Cookie gesetzt ist wird der Highscore aus dem Cookie gelesen,
	//andernfalls ist er 0
	this.maxScore = (getCookie('maxScore') == false) ? 0 : getCookie('maxScore');

	//Soundarrays KI || USR

    this.current_KI_chain = [];
    this.current_USR_chain = [];

	  
    //====================== 
    // !!DEFAULT!!

    	this.webAudioAPI = Modernizr.webaudio; 

	
	//=======================

    //_______________________ USER Object
    
    this.USR = {      
      turn : false,
    };
		
	//_______________________ Elements
	
	this.game_body = document.getElementById('Soundabout');

    this.game_holder = document.getElementById('Game');
    this.game_submit = document.getElementById('game-submit');
    this.game_input = document.getElementById('game-input');
    this.game_start = document.getElementById('game-start');
    this.game_start_2 = document.getElementById('game-start-2');
    this.game_start_3 = document.getElementById('game-start-3');

    this.game_tut = document.getElementById('game-tutorial');
    this.game_retry = document.getElementById('game-retry');
    this.game_share = document.getElementById('game-share');


    this.game_ui_slide_start = document.getElementById('slide-1');
    this.game_ui_slide_tutorial = document.getElementById('slide-2');
    this.game_ui_slide_tutorial_2 = document.getElementById('slide-3');

    this.game_tut_text_1 = document.getElementById('tut-text-1');
    this.game_tut_text_2 = document.getElementById('tut-text-2');
	
	this.game_ui_mode_moki = document.getElementById('radio-mode-moki');
	this.game_ui_mode_xmas = document.getElementById('radio-mode-xmas');
	this.game_ui_mode_switch = document.getElementById('ui-mode');
	this.game_ui_mode_switch_inner = document.getElementById('switch-modes');

	this.game_score = document.getElementById('game-ui-user-score');
	this.game_max_score = document.getElementById('game-ui-score');
	this.game_ui_points = document.getElementById('game-ui-points');

	this.text_score = document.getElementById('score-text');
	this.text_score_max = document.getElementById('score-text-max');
	this.score_message_1 = document.getElementById('score-message-1');
	this.score_message_2 = document.getElementById('score-message-2');

	this.game_close = document.getElementById('ui-close');

	this.game_ui_info = document.getElementById('game-ui-info');


	//Set score from Cookie or initial at 0
	this.game_max_score.innerHTML = this.maxScore;


	//_______________________ GAME LANGUAGE SWITCH
	
	this.switch_Language = function(lang){
		
		lang_DATA = {
			en : {
				buttons : {
					start : "Play now",
					tut : "How to play",
					start1 : "next",
					start2 : "Yes, let's go!",
					screen:{
						one : "Listen‘ carefully and repeat the sounds by clicking on the correct buttons! First there will be one sound, then two, then three… remember them in the right order to get a good score!",
						two : "By the way, if you pay attention on the road, you're sure to recognise one or more sounds. Can we start?"

					},
					UI : {
						score : "Score",
						record : "Best",
						retry : "Play again",
						share : "Share result on Facebook",
						looserMessage : "Fantastic! You have achieved",
						looserMessage2 : "points.</br> But you can do even better, can't you?"

					}
				}
			},
			de : {
				buttons : {
					start : "Spiel starten",
					tut : "So wird gespielt",
					start1 : "Weiter",
					start2 : "Ja, los!",
					screen:{
						one : "Hör genau zu und klicke anschließend selbst auf die Geräuschbuttons! Zuerst ist es einer, dann zwei, dann drei… mit der richtigen Reihenfolge bist du gut dabei!",
						two : "Ach ja, wenn du im Straßenverkehr gut aufpasst, dann kommt dir das ein oder andere Geräusch sicher bekannt vor. Kann es losgehen?"

					},
					UI : {
						score : "Deine Punkte",
						record : "Dein Rekord",
						retry : "Noch einmal spielen",
						share : "Punkte auf facebook teilen",
						looserMessage : "Top! Du hast",
						looserMessage2 : "Punkte erreicht.</br> Da geht aber noch mehr, oder?"					
					}
				}
			}
		}
		
		that.game_start.innerHTML = lang_DATA[lang].buttons.start;
		that.game_tut.innerHTML = lang_DATA[lang].buttons.tut;
		that.game_start_2.innerHTML = lang_DATA[lang].buttons.start1;
		that.game_start_3.innerHTML = lang_DATA[lang].buttons.start2;

		that.game_tut_text_1.innerHTML = '<p>'+lang_DATA[lang].buttons.screen.one + '</p>';
		that.game_tut_text_2.innerHTML = '<p>'+lang_DATA[lang].buttons.screen.two + '</p>';
		
		that.text_score.innerHTML = lang_DATA[lang].buttons.UI.score;
		that.text_score_max.innerHTML = lang_DATA[lang].buttons.UI.record;
		that.game_retry.innerHTML = lang_DATA[lang].buttons.UI.retry;
		that.game_share.innerHTML = lang_DATA[lang].buttons.UI.share;
		that.score_message_1.innerHTML = lang_DATA[lang].buttons.UI.looserMessage;
		that.score_message_2.innerHTML = lang_DATA[lang].buttons.UI.looserMessage2;

	}

	this.game_lang = window.location.search.split('?')[1];
	if(typeof this.game_lang == "undefined"){
		this.game_lang = 'de';
	}

	if(this.game_lang=='en'){
		this.switch_Language('en');
	}
	


	//_______________________ Methods

	/*
		return den Game Mode der gewählt wurde
	*/

	this.getGameMode = function(){
		if(that.game_ui_mode_xmas.checked && !that.game_ui_mode_moki.checked){
			that.game_ui_mode_switch_inner.setAttribute('data-switch-type','xmas');
			that.game_body.setAttribute('data-game-mode','xmas');
			return 'xmas';
		}
		if(that.game_ui_mode_moki.checked && !that.game_ui_mode_xmas.checked){
			that.game_ui_mode_switch_inner.setAttribute('data-switch-type','moki');
			that.game_body.setAttribute('data-game-mode','moki');
			return 'moki';
		}
		
		//zur Sicherheit falls der Input "undefined" liefert
		if(that.game_ui_mode_xmas.checked === that.game_ui_mode_moki.checked){
			that.game_ui_mode_switch_inner.setAttribute('data-switch-type','xmas');
			that.game_body.setAttribute('data-game-mode','xmas');
			that.game_ui_mode_moki.checked != that.game_ui_mode_moki.checked;
			return 'xmas';
		}
	};
	


	//_______________________ ffSwitch Mode - event
	
	/*
		Button um den Game Mode zu switchen
	*/
	this.game_ui_mode_switch.addEventListener('click',function(){

		that.game_ui_mode_moki.checked = !that.game_ui_mode_moki.checked;
		that.game_ui_mode_xmas.checked = !that.game_ui_mode_xmas.checked;
	
		// Switch Game Sounds
		// 
		that.switch_AudioFiles(that.getGameMode());

		that.getAudioFiles();
		
		//console.log(that.getGameMode());
	});

	

	//_______________________ Loader
	/*
		überwacht das Laden der AudioFiles
		return einen Array mit den AudioDateien
	*/
	this.getAudioFiles = function(){
		var ready = 0;

		that.audioFiles.forEach(function(a,index){
			a._ID = index;
			 // Falls das Loading der Sounds unterbrochen wird
			 // kann man es so wieder anstupsen 
		   a.onstalled = function() {
				this.load();
				this.play();
				this.pause();
			}
			//wenn audio komplett geladen wurde
			a.oncanplaythrough = function() {
				ready++;
				if(ready===9){

					that.ready = true;
					var hasClassReady = hasClass(that.game_body, 'game-is-ready');
					if(!hasClassReady){
      					that.game_body.className += ' game-is-ready';
					}
				}				
			};
			//während des ladens
			a.onprogress =function(){
				var hasClassLoading = hasClass(that.game_body, 'game-is-loading');
				if(!hasClassLoading){
					that.game_body.className += ' game-is-loading';
				}
			};
			//wenn ein Ton komplett abgespielt wurde setzt er den data-state von true auf false
			a.onended = function(){
				this.pause();
				this.currentTime = 0;
				that.buttons[this._ID].setAttribute('data-state','false');
			};
		});
		return that.audioFiles;
	};

	//_______________________ Switch source on Audio Elements
	/*
		Switched die source dateien zwischen Moki | XMAS - Mode
	*/

	this.switch_AudioFiles = function(mode){

		//switched die audio source im HTML
		//nur wichtig wenn Webaudio nicht unterstützt wird
        that.audioFiles.forEach(function(el,index){
			var sources = el.getElementsByTagName("source");
			for(var i=0;i<sources.length;i++){
				var sourceItem = (sources[i].src).split('/');
				sourceItem[sourceItem.length-2] = mode;				
				sources[i].src =  sourceItem.join('/');					
			}
			el.load();
        });
        
		//setzt die Source für den AudioBuffer

        that.sounds = [
			base_url+ mode +'/01.mp3',
			base_url+ mode +'/02.mp3',
			base_url+ mode +'/03.mp3',
			base_url+ mode +'/04.mp3',
			base_url+ mode +'/05.mp3',
			base_url+ mode +'/06.mp3',
			base_url+ mode +'/07.mp3',
			base_url+ mode +'/08.mp3',
			base_url+ mode +'/09.mp3',
        ]

        that.init();
    };
	
	
	
	//_______________________ Push correct Button Clicks to Database

	function pushClickCount(count){

		// Set up the AJAX request
		var request = new XMLHttpRequest();
		var chk = Math.floor(Math.sqrt(count) * 2171.5) % 21335;

		var param = "/add/soundabout/ANONYMOUS/" + count + "/" + chk;

		request.open('POST', data_url+param, true);
		
		request.send(param);
		request.onreadystatechange = function () {
			
			if (request.readyState < 4){
				//console.log('waiting on response from server');
			}
			else if (request.readyState === 4) {
				// 200 - 299 = successful
				if (request.status == 200 && request.status < 300){
					//console.log('success',request);
				}
				else{
					//console.log('failure',request);
				}
			}
		}
		//console.log('pushClickCount' , count);
	}

	
	//_______________________ Start Button
	/*
		Button Starte das Spiel
	*/

	function starter(event){

		if(typeof event !="undefined"){
			event.preventDefault(event);
		}
		//console.log(that.ready);
		if(that.ready){
			that.game_body.setAttribute('data-state','game');
			that.game_holder.setAttribute('data-game-state','playing');

				that.game_body.setAttribute('data-turn','KI');

				
			  //Startet und stoppt den ersten Ton
				//iOS spielt sonst nicht den ersten Sound ab
				if(that.webAudioAPI){				
				  var sound = context.createBufferSource();
					  sound.buffer = that.bufferList[1];  

					  sound.connect(context.destination);

					  sound.start(0);//start(0)
					  sound.stop(0);
					  
				}
				
				that.start_level_loop();

            // Ereignis tracken
            tracker.trackPageView('Spiel starten');

		}

     }

     this.game_start.addEventListener('click',starter);
     this.game_start_3.addEventListener('click',starter);

     this.game_tut.addEventListener('click',function(event){
     	event.preventDefault(event);
     	that.game_body.setAttribute('data-state','tutorial');
     });
     this.game_start_2.addEventListener('click',function(event){
     	event.preventDefault(event);
     	that.game_body.setAttribute('data-state','tutorial-2');
     })

     //_______________________ Restart Spiel
     /*
		Button retry
	 */
     this.game_retry.addEventListener('click',function(){
     		that.game_holder.setAttribute('data-game-error','');
     		that.score_secret = 0;
     		starter();
     });
    //_______________________ SHARE BUTTON
    function _window_open(url, width, height, tracking_title) {
		
		window.open(url, '_blank', 'width=' + width + ',height=' + height + ',left=100,top=200,scrollbars=yes');
		
		// Ereignis tracken
		//var t = Piwik.getTracker(Drupal.settings.piwik.tracker_url + 'piwik.php', Drupal.settings.piwik.site_id);
		//t.trackPageView([Drupal.settings.locale, 'Social Buttons', tracking_title].join('/'));
	}

    this.game_share.addEventListener('click',function(event){
    	event.preventDefault(event);

		// Share-URL zusammensetzen
			var url = 'https://www.facebook.com/sharer.php?u=';
			var checkParent = inIframe();
			var page_url = '';
			if(checkParent){
				page_url += window.parent.location.protocol;
				page_url += '//';
				page_url += window.parent.location.host;
				page_url += window.parent.location.pathname;
				page_url += window.parent.location.search;
				
				//console.log(page_url);
			}
			
			page_url = encodeURI(page_url);
			
			url += page_url;
			url += '?score='+ that.score_secret;
			
			// Popup oeffnen
			_window_open(url, 830, 500, 'Facebook');   
    });


    //_______________________ GAME 
	/*
		Definiert den Context
		Wenn AudioContext unterstützt wird nimmt er die AudioFiles die oben defininert sind
		wenn nicht: Statische Audio Elemente aus dem HTML Dokument

		Testen: Derzeit ist der WebaudioContext für alle Geräte deaktiviert
		Standard: HTML AUDIO Elemente

	*/

	this.game_ui_info.addEventListener('click',function(event){
		event.preventDefault(event);
     	that.game_body.setAttribute('data-state','mid-info');
    });

    //_______________________ CLOSE INFO MENU
	this.game_close.addEventListener('click',function(event){
		event.preventDefault(event);
		
		if(that.game_body.getAttribute('data-state') ==="mid-info"){
			//console.log(game-state);
     		that.game_body.setAttribute('data-state','game');
     	}
     	else{
     		//console.log('go Back to First Screen');
     		that.game_body.setAttribute('data-state','tutorial');
     		that.reset();
     	}
	});

    this.init = function(){
    	//Fragt den aktuellen GameMode ab
		// und setzt die richtigen Daten Attribute auf dem Game Holder
      	that.getGameMode();

		var isAudioContextSupported = function () {
				// This feature is still prefixed in Safari
				// Fix up prefixing
      			window.AudioContext = window.AudioContext || window.webkitAudioContext;
      
				if(that.webAudioAPI){//window.AudioContext
					 that.webAudioAPI = true;
					return true;
				}
				else {
					that.webAudioAPI = false;
					that.audioFiles = that.getAudioFiles();

					return false;
				}
			};
			
			if(isAudioContextSupported()) {
				
				if(typeof context == "undefined" ){
					context = new AudioContext();
				}
				// Load Sounds
				  this.bufferLoader = new BufferLoader(context,this.sounds,this.finishedLoading);
				  this.bufferLoader.load();
			}
      
		
    };
    
    //_______________ Play single Sound
    /*
		Spielt einen Sound ab (WebaudioContext || HTML AudioFiles)
		Braucht die ID des Sounds

	*/

    this.playSound = function(ID){
    	    	
		if(this.webAudioAPI){

			  var sound = context.createBufferSource();
				  sound.buffer = this.bufferList[ID];  

				  sound.connect(context.destination);
				  
				  sound.start(0);//start(0)
				
				
					//if(typeof sound.noteOn != "undefined"){
					//	console.log(typeof sound.noteOn);
					//	sound.noteOn(0);
					//	sound.play();
					//}

				  // -> Deprecated, but for iPad
				  //  sound.noteOn(0);

				 that.buttons[ID].setAttribute('data-state','true');
				 that.game_body.setAttribute('data-play-sound','true');
				 
				 setTimeout(function(){
				 	that.buttons[ID].setAttribute('data-state','false');
				 	that.game_body.setAttribute('data-play-sound','false');
				 },1000);
				 

				//sound.onended = function(){
				//	//console.log(this.buffer._ID, 'has ended');
				//	that.buttons[that.buffer._ID].setAttribute('data-state','false');
				//	that.game_body.setAttribute('data-play-sound','false');
				//};
						  

			  // Returns duration to provide Start Time
			  // for next sound
			  return this.bufferList[ID].duration;      
    	}
    	else{
			that.audioFiles[ID].play();
				that.audioFiles[ID].ontimeupdate = function(){
					if(this.currentTime>.7){
						that.buttons[ID].setAttribute('data-state','false');
						that.game_body.setAttribute('data-play-sound','false');
						
					}				  	
				}
			that.buttons[ID].setAttribute('data-state','true');
			that.game_body.setAttribute('data-play-sound','true');

    	}
    };
    
    //_______________________ When everything is loaded
    /*
		Wenn die sounds geladen sind kann das Spiel als 
		"spielbereit" markiert werden
	*/
    this.finishedLoading = function (bufferList) {
      
      bufferList.forEach(function(sound,index){
        sound._ID = index;
      });

      that.bufferList = bufferList;
      that.ready = true;
      var hasClassReady = hasClass(that.game_body,'game-is-ready');
      if(!hasClassReady){
	      that.game_body.className += ' game-is-ready';
      }
    };

    //_______________________ LOGIC LAYER
	/*
		Starte die Spielrunde
		this.speed ist die Geschwindigkeit mit der gespielt wird

	*/
    this.start_level_loop = function(){
      var next_random_sound = Math.abs(Math.round(Math.random()*this.sounds.length-1));

      if(next_random_sound==this.current_KI_chain[this.current_KI_chain.length-1]){
      	next_random_sound = Math.abs(Math.round(Math.random()*this.sounds.length-1));
      }
      this.current_KI_chain.push(next_random_sound);
      var current = 0;
      
	
		//Interval Function
      function intervalFunction() {
	
		if(current < that.current_KI_chain.length){
 	      that.playSound(that.current_KI_chain[current]);
 	     
 	    }else{
				clearInterval(interval);
				that.USR.turn = true;
				that.game_body.setAttribute('data-turn','USER');
			}
			current++;
		}

      var interval = setInterval(intervalFunction, this.speed);
    };

    //_______________________ CHECK USER INPUT
    /*
		Setzt das Spiel und alle Werte zurück
	*/

    this.restartGame = function(){

      that.game_holder.setAttribute('data-game-error','loose');
      that.game_holder.setAttribute('data-game-state','start');
      that.game_body.setAttribute('data-state','mid');
      
      this.reset();
    };

    //_______________________ CHECK USER INPUT
	/*
		Überprüft die Eingabe des Spielers gegenüber der KI
		wenn falsches Ergebnis zeigt er automatisch den Restart-Bildschirm wieder an

	*/
    this.check_USR_sound = function(ID){      
      this.current_USR_chain.push(parseFloat(ID));

      		
	//wenn der User das richtige Ergebnis eingegeben hat
      
      if(this.current_USR_chain[this.current_USR_chain.length-1] === this.current_KI_chain[this.current_USR_chain.length-1]){
       
        //console.log('correct');
        this.clickCounter++;
        this.score += 10 * this.level;
        if(this.score % 100 == 0){
        	this.level++;
        	//console.log('next level');
        }

        if(this.score > this.maxScore){
			//console.log('set max at',this.score);
			this.maxScore = this.score;
			this.game_max_score.innerHTML = this.maxScore;
			document.cookie = 'maxScore='+this.maxScore;

		}
		this.game_score.innerHTML = '<span class="newPoint">'+ this.score + '</span>';

          // Ereignis tracken
          tracker.trackPageView('Geräusch richtig erraten');
		
			
        if(this.current_USR_chain.length === this.current_KI_chain.length){
          that.USR.turn = false;
          that.game_body.setAttribute('data-turn','KI');
          that.current_USR_chain = [];
          
            var interval = setInterval(function() {
              that.start_level_loop();
              clearInterval(interval);
            },this.speed * 1);
        }
      }

      //wenn nicht
      // Zeige zuerst Ergebnisslide
      // Reset Values
      else{
        this.restartGame();
      }
    };
	
	//_______________________ Methode
	/*
		setzt alle Werte im Spiel zurück
	*/
	this.reset = function(){
		this.current_KI_chain = [];
		this.current_USR_chain = [];
		this.level = 1;
		
		// SET MAXIMUM POINTS
		if(this.score > this.maxScore){
			//console.log('set max at',this.score);
			this.maxScore = this.score;
			this.game_max_score.innerHTML = this.maxScore;
			document.cookie = 'maxScore='+this.maxScore;


		}
		pushClickCount(this.clickCounter);
		this.score_secret = this.score;
		this.game_ui_points.innerHTML = this.score;
		this.score = 0;
		this.clickCounter = 0;
		this.game_body.setAttribute('data-turn','KI');
		this.game_score.innerHTML = this.score;
		this.game_max_score.innerHTML = this.maxScore;
	};
	
	//_______________________ CHECK USER INPUT
	/*
		Spielbuttons UI
	*/

    this.buttons.forEach(function(b,index){
      b.addEventListener('click',function(event){

       var sound_ID = this.getAttribute('data-id');

        if(that.USR.turn){            
           that.playSound(sound_ID);           
           that.check_USR_sound(sound_ID);
        }
        
      },false);



    });
  	
    //_______________________ KICK IT OFF
    this.init();  
}
  


var game = new GAME();


}());